import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { oidcClientId, oidcIssuer } from '../config';

/** Authorization-code flow with PKCE against Keycloak (Technical Specifications, 7.2 and 13.1). */
export const userManager = new UserManager({
  authority: oidcIssuer,
  client_id: oidcClientId,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

/**
 * The Keycloak account console (password, sessions, devices) in the language of the portal, with
 * a link back to it ("Retour à Gestion des déchets", the name of the client).
 */
export function accountConsoleUrl(locale: string): string {
  const params = new URLSearchParams({
    referrer: oidcClientId,
    referrer_uri: `${window.location.origin}/`,
    kc_locale: locale,
  });
  return `${oidcIssuer}/account/?${params}`;
}
